import {
  Component,
  ElementRef,
  ViewChild,
  CUSTOM_ELEMENTS_SCHEMA,
  AfterViewChecked,
  PLATFORM_ID,
  inject,
  NgZone,
  ChangeDetectorRef,
  EventEmitter,
  HostListener, AfterViewInit
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ApidataService } from '../apidata.service';
import { IconsComponent } from '../editor/additional/icons/icons.component';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { ToolbarComponent } from '../editor/additional/toolbar/toolbar.component';

import { MarkdownModule } from 'ngx-markdown';
import { NgxTypedWriterModule } from 'ngx-typed-writer';
import { ModalComponent } from '../editor/additional/modals/modal.component';
import { EmptyContentComponent } from '../editor/additional/placeholders/empty-content.component';
import { PremiumUserComponent } from '../editor/additional/placeholders/premium-user.component';
import { UploadFileComponent } from '../editor/additional/placeholders/upload-file.component';
import { NewSidebarComponent } from '../sidebar-new/sidebar-addtional/new-sidebar/new-sidebar.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';

import { environment } from '../../environments/environments';
import { HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { registerErrorSpanBlot } from '../editor/additional/custom-blots';
import { HeaderComponent } from '../header/header.component';
import { Renderer2 } from '@angular/core';
const ignoredKeys = [
  'Shift',
  'Control',
  'Alt',
  'Meta',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'CapsLock',
  'Tab',
  'Escape',
];
@Component({
  selector: 'app-editor-mobile-view',
  standalone: true,
  imports: [
    CommonModule,
    HttpClientModule,
    NgCircleProgressModule,
    HttpClientModule,
    IconsComponent,
    UploadFileComponent,
    HeaderComponent,
    CommonModule,
    HttpClientModule,
    IconsComponent,
    MarkdownModule,
    ModalComponent,
    NgxTypedWriterModule,
    IconsFreeToolsComponent,
    NgCircleProgressModule,
    UploadFileComponent,

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './editor-mobile-view.component.html',
  styleUrl: './editor-mobile-view.component.css',
})
export class EditorMobileViewComponent implements AfterViewChecked {
  @ViewChild('messagesContainer') messagesContainer: ElementRef;
  @ViewChild('richTextEditor') richTextEditor: any;

  @ViewChild('editor', { static: true }) editorElement!: ElementRef;
  @ViewChild('editorToolbar', { static: true }) toolbarElement!: ElementRef;

  private platformId = inject(PLATFORM_ID);
  private ngZone = inject(NgZone);

  editorLoaded: boolean = false;

  editorEnabled: boolean = localStorage.getItem('editorValueAI') ? true : false;
  allowTypeWriter: boolean = true;
  resultsCollapsed: boolean = false;
  suggestionsTone: boolean = false;
  resultsSectionPanel: 'resultsSection' | 'aiAssistant' = 'resultsSection';
  profile_id: string = '';
  aiAssistantQueries: Array<{
    question: string;
    answer: string;
    loaded: boolean;
  }> = [];
  isAiAssistantQueriesLoading: boolean = false;
  private userInteracted: boolean = false;
  private debounceTimeout: ReturnType<typeof setTimeout> | null = null;
  private docSaveTimeout: ReturnType<typeof setTimeout> | null = null;
  private safeCursorIndex: number = 0;
  openMenu: HTMLElement | null = null;
  quillEditor: any;
  editorState = {
    doc_id: this.router.url.split('/').pop(),
    words: 0,
    characters: 0,
    sentences: 0,
    sentenceLength: 0,
    wordsLength: 0,
    score: 100,
    aiContentScore: 0,
    plagiarism: {
      plagiarismScore: 0,
      isPlagiarized: false,
    },
    oldBatch: '',
    batch: '',
    chunks: [],
    results: {},
    errors: {},
    tone: {},
    status: {
      readability: 0,
      all: 0,
      accuracy: 0,
      clarity: 0,
      style: 0,
      syntax: 0,
      grammar: 0,
      positive: 0,
      negative: 0,
      neutral: 0,
      reading_time: 0,
      speaking_time: 0,
    },
    formality: 'formal',
    domain: 'general',
    state: 'initial',
    grammarStatus: 'initial',
    filteredErrors: {},
    filteredSuggestions: {},
  };
  showErrorsByType: 'all' | 'accMode' | 'clrMode' | 'styleMode' | 'syntaxMode' =
    'all';
  showToneSuggestionsByType: 'all' | 'positive' | 'negative' | 'neutral' =
    'all';

  showTargets: boolean = false;
  showTargetsCheckboxValue: boolean = false;
  authTitle: string;
  authState: 'guest' | 'auth' | 'pro' = 'auth';
  authLimits = {
    guest: {
      words: 100,
      prompts: 0,
    },
    auth: {
      words: 5000,
      prompts: 3,
    },
    pro: {
      words: 10000,
      prompts: 2000,
    },
  };
  promptsUsed = 0;
  aiDetectorLimitLeft = 0;
  plagCheckerLimitLeft = 0;

  modules = {
    toolbar: [
      [
        'bold',
        'italic',
        'underline',
        { align: '' },
        { align: 'center' },
        { align: 'right' },
        { align: 'justify' },
        { list: 'ordered' },
        { list: 'bullet' },
        'blockquote',
      ],
    ],
    history: {
      delay: 2000,
      maxStack: 100,
      userOnly: true,
    },
  };

  dictionary;

  languages: Record<string, { icon: string; name: string }> = {
    'en-us': {
      icon: 'americanFlag',
      name: 'English US',
    },
    'en-gb': {
      icon: 'britishFlag',
      name: 'English UK',
    },
    'en-ca': {
      icon: 'canadianFlag',
      name: 'English CAN',
    },
    'en-au': {
      icon: 'australianFlag',
      name: 'English AUS',
    },
    // 'en-in': {
    //   icon: 'indiaFlag',
    //   name: 'English IND',
    // },
    de: {
      icon: 'germanFlag',
      name: 'German',
    },
    es: {
      icon: 'spanishFlag',
      name: 'Spanish',
    },
    pt: {
      icon: 'portugueseFlag',
      name: 'Portuguese',
    },
  };
  selectedLanguage: keyof typeof this.languages = 'en-us';

  protected Object = Object;
  protected JSON = JSON;

  private textProcessingRequestSignal$ = new Subject<void>();
  private grammarCheckerRequestSignal$ = new Subject<void>();
  private toneProcessingRequestSignal$ = new Subject<void>();

  private grammarCheckerRequestCanceled: boolean = false;

  iconRequireReattachment = false;

  constructor(
    private apiDataService: ApidataService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
    this.loadFromLocalStorage();
  }

  ngAfterViewInit(): void {

    this.loadEditor();
    this.route.queryParams.subscribe((params) => {
      const docId = params['doc'];
      if (docId) {
        this.editorState.doc_id = docId;
        this.editorState.plagiarism.plagiarismScore = 0;
        this.editorState.status.readability = 0;
        this.editorState.aiContentScore = 0;
        this.unsetErrors();
        this.editorEnabled = false;
      }
    });



    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.getBrowserWidth();
        if (this.profile_id !== '1') {
          this.apiDataService
            .getUserProfileContents(this.profile_id)
            .subscribe((data) => {
              this.authTitle = data.contents[0][5];
              if (
                data.contents[0][5] === 'premium_user' ||
                data.contents[0][5] === 'free_trial'
              ) {
                this.authState = 'pro';
              } else {
                this.authState = 'auth';
              }
              this.showTargets = data.contents[0][6];
              this.showTargetsCheckboxValue = data.contents[0][6];
              this.promptsUsed =
                this.authLimits[this.authState].prompts -
                data.contents[0][7].prompts;
              this.aiDetectorLimitLeft = data.contents[0][7].ai;
              this.plagCheckerLimitLeft = data.contents[0][7].plag;
            });

          this.apiDataService
            .getPreferredLangByProfileID(this.profile_id)
            .subscribe((data) => {
              const language = data.contents.toLowerCase();
              this.selectedLanguage = this.languages.hasOwnProperty(language)
                ? language
                : 'en-us';
              this.iconRequireReattachment = true;
              setTimeout(() => {
                this.iconRequireReattachment = false;
              });
            });

          this.apiDataService
            .getAllDictionaryWords(
              this.profile_id,
              localStorage.getItem('token')
            )
            .subscribe((data) => {
              this.dictionary = data.contents;
            });
        } else {
          this.authState = 'guest';
        }
        this.apiDataService
          .onloadcontentresquest(this.profile_id, this.editorState.doc_id)
          .subscribe((data) => {
            const content = new DOMParser()
              .parseFromString(data.outConts, 'text/html')
              .body.textContent.trim();
            if (content.length) {
              this.editorEnabled = true;
              this.quillEditor.root.innerHTML = data.outConts.replace(
                /\n/g,
                '<br>'
              );

              //   if (this.showTargets) {
              //     document.getElementById('set-targets-modal').style.display =
              //       'grid';
              //   }
              //   this.handleTextChange();
              // } else if (localStorage.getItem('editorValueAI')) {
              //   this.quillEditor.root.innerHTML =
              //     localStorage.getItem('editorValueAI');
              //   if (this.showTargets) {
              //     document.getElementById('set-targets-modal').style.display =
              //       'grid';
              //   }
              this.handleTextChange();
            }

            localStorage.removeItem('editorValueAI');
          });

        document.addEventListener('click', this.handleClickOutside);
      }, 0);
    }
  }

  private loadEditor() {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        import('ngx-quill').then((module) => {
          import('quill').then((quillModule) => {
            this.ngZone.run(() => {
              this.initializeEditor(module, quillModule);
            });
          });
        });
      });
    }
  }

  private initializeEditor(quillModule: any, quillImport: any) {
    const Quill = quillImport.default;

    registerErrorSpanBlot(Quill);

    this.editorLoaded = true;

    const editorConfig = {
      modules: {
        toolbar: {
          container: this.toolbarElement.nativeElement,
        },
      },
      placeholder: '',
      theme: 'snow',
    };

    this.quillEditor = new Quill(
      this.editorElement.nativeElement,
      editorConfig
    );

    this.quillEditor.root.id = 'mm';

    this.addEventListeners();
    setTimeout(() => {
      this.loadEditorContent();
    }, 10);
  }
  private loadEditorContent() {
    if (localStorage.getItem('editorValueAI')) {
      const content = new DOMParser()
        .parseFromString(localStorage.getItem('editorValueAI'), 'text/html')
        .body.textContent.trim();
      if (content.length) {
        this.editorEnabled = true;
        this.quillEditor.root.innerHTML = localStorage
          .getItem('editorValueAI')
          .replace(/\n/g, '<br>');
        localStorage.removeItem('editorValueAI');
        if (this.showTargets) {
          document.getElementById('set-targets-modal').style.display = 'grid';
        }
        this.handleTextChange();
      } else {
        this.editorEnabled = false;
      }
    } else {
      this.editorEnabled = false;
      this.apiDataService
        .onloadcontentresquest(this.profile_id, this.editorState.doc_id)
        .subscribe((data) => {
          const content = new DOMParser()
            .parseFromString(data.outConts, 'text/html')
            .body.textContent.trim();
          if (content.length) {
            this.editorEnabled = true;
            this.quillEditor.root.innerHTML = data.outConts.replace(
              /\n/g,
              '<br>'
            );
          } else {
            this.editorEnabled = false;
          }
          if (this.showTargets) {
            document.getElementById('set-targets-modal').style.display = 'grid';
          }
          this.handleTextChange();
        });
    }

    document.addEventListener('click', this.handleClickOutside);
  }
  private addEventListeners() {
    if (!this.quillEditor) return;

    const q = this.quillEditor;

    q.on('text-change', () => {
      this.computeWordsAndCharactersCount();
      this.editorEnabled = true;

      if (localStorage.getItem('file_uploaded')) {
        this.handleCheckGrammarButton();
      }
    });

    q.root.addEventListener('click', (event: MouseEvent) => {
      this.handleEditorClick(event);
      this.onclickeditor(event, '');
    });

    q.root.addEventListener('keyup', (event: KeyboardEvent) => {
      // this.handleTextChange(event);
    });

    q.root.addEventListener('paste', (event: ClipboardEvent) => {
      this.handleCheckGrammarButton();
    });

    q.root.addEventListener('blur', () => {
      this.editorEnabled =
        !!this.editorState.characters ||
        this.quillEditor.root.innerHTML !== '<p><br></p>';
    });
  }

  renderEditor() {
    this.editorEnabled = !this.editorEnabled;

    setTimeout(() => {
      this.quillEditor.root.focus();
    }, 200);
  }

  ngAfterViewChecked(): void {
    if (!this.userInteracted) this.scrollToBottom();
  }

  unsetErrors() {
    this.editorState.oldBatch = this.editorState.batch;
    this.editorState.batch = '';
    this.editorState.results = {};
    this.editorState.errors = {};
    this.editorState.filteredErrors = {};
    this.editorState.status = {
      ...this.editorState.status,
      all: 0,
      accuracy: 0,
      clarity: 0,
      style: 0,
      syntax: 0,
    };
  }

  getBrowserWidth() {
    const width = window.innerWidth;

    if (width < 600) {
      this.router.navigate(['/document-lite/', this.editorState.doc_id]);
    } else if (width < 868) {
      this.router.navigate(['/document-tab/', this.editorState.doc_id]);
    }
    else {
      this.router.navigate(['/grammar-check'], {
        queryParams: { doc: this.editorState.doc_id },
      });
    }
  }

  clearEditor() {
    this.cancelGrammarCheckerRequest();
    this.unsetErrors();
    this.editorState.status = {
      ...this.editorState.status,
      readability: 0,
    };
    this.quillEditor.setText(null);
    this.editorState.words = 0;
    this.editorState.characters = 0;
    setTimeout(() => this.saveEditorText(), 500);
    this.editorEnabled = false;
    this.suggestionsTone = false;
    this.popupVisible = false;

  }

  saveEditorText() {
    const content = this.quillEditor.root.cloneNode(true) as HTMLElement;
    const highlights = content.querySelectorAll('span');
    const unchecked = content.querySelectorAll('.E93fKL-PD_2');

    unchecked.forEach((el) => el.removeAttribute('class'));

    highlights.forEach((highlight) => {
      const parent = highlight.parentElement;
      while (highlight.firstChild) {
        parent.insertBefore(highlight.firstChild, highlight);
      }
      parent.removeChild(highlight);
    });

    this.apiDataService
      .auto_saved_Api(
        this.profile_id,
        'Grammar Checker - (Grammar Editor)',
        'Grammar Checker - (Grammar Editor)',
        content.innerHTML,
        this.editorState.doc_id,
        'editor'
      )
      .subscribe();
  }

  handleCheckGrammarButton() {
    localStorage.removeItem('file_uploaded');
    this.quillEditor.enable(false);
    this.unsetErrors();

    this.removeErrorHighlightsFromText();

    this.editorState.batch = '';

    this.quillEditor.root
      .querySelectorAll('img')
      .forEach((img) => img.remove());

    setTimeout(() => {
      if (this.quillEditor.root.innerText.trim().length === 0) {
        this.quillEditor.root
          .querySelectorAll('img')
          .forEach((img) => img.remove());
        this.quillEditor.enable();
        return;
      }

      this.quillEditor.root.innerHTML = this.convertTablesToParagraphs(
        this.convertDivsToParagraphs(this.quillEditor.root.innerHTML)
      );

      this.computeWordsAndCharactersCount();

      if (this.editorState.words > 10000) {
        document.getElementById(
          'content-exceeds-words-limit-modal'
        ).style.display = 'grid';
        this.quillEditor.enable();
        return;
      }

      setTimeout(() => {
        const length = this.quillEditor.getLength();
        this.quillEditor.setSelection(length - 1, 0);
      }, 0);

      this.editorState.state = 'loading';
      this.saveEditorText();
      this.handleTextChange(null, true);
    }, 100);
  }

  handleTextChange(event?: KeyboardEvent, setState?: boolean) {
    if (this.debounceTimeout) clearTimeout(this.debounceTimeout);

    if (this.docSaveTimeout) clearTimeout(this.docSaveTimeout);

    this.grammarCheckerRequestSignal$.next();
    if (!setState) {
      this.editorState.grammarStatus = 'initial';
      this.editorState.state = 'initial';
    }

    this.computeWordsAndCharactersCount();

    this.docSaveTimeout = setTimeout(() => this.saveEditorText(), 10000);

    this.debounceTimeout = setTimeout(
      () => {
        let content = this.quillEditor.root.innerHTML;

        if (this.quillEditor.root.innerText.trim().length === 0) {
          this.editorState.state = 'initial';
          this.editorState.grammarStatus = 'initial';
          this.quillEditor.enable();
          this.clearEditor();
          return;
        }

        if (event && ignoredKeys.includes(event.key)) return;

        const selection = this.quillEditor.getSelection();
        this.safeCursorIndex = selection
          ? selection.index
          : this.quillEditor.getLength();

        if (this.editorState.words > this.authLimits[this.authState].words) {
          this.quillEditor.root.innerHTML = this.splitTextByWordLimit(
            this.quillEditor.root.innerHTML
          );
          content = this.getQuillEditorFilteredText();
        }

        if (this.authState !== 'guest') {
          // this.detectAIContent();
          this.checkPlagiarism();
        }

        if (!this.editorState.batch) {
          this.quillEditor.enable(false);
          this.editorState.state = 'loading';
        }

        if (this.editorState.batch) {
          const [leafNode] = this.quillEditor.getLeaf(this.safeCursorIndex);
          let node = leafNode.parent;

          if (
            this.editorState.chunks.length !==
            Array.from(this.quillEditor.root.children).filter(
              (child) =>
                !(child as HTMLElement).classList.contains('E93fKL-PD_2')
            ).length
          ) {
            this.unsetErrors();
            this.handleTextChange();

            return;
          }

          while (node && node.id !== this.quillEditor.root.id) {
            if (this.editorState.chunks.includes(node.domNode.id)) {
              this.suggestionsTone
                ? this.checkTone()
                : this.checkGrammar([node.domNode.id], true);

              return;
            }

            node = node.parent;
          }
          this.unsetErrors();
          this.handleTextChange();

          return;
        }

        this.apiDataService
          .break_sentence(
            this.editorState.oldBatch,
            content,
            this.editorState.doc_id,
            {
              domain: this.editorState.domain,
              formality:
                this.editorState.domain === 'academic'
                  ? ''
                  : this.editorState.formality === 'neutral'
                    ? 'formal'
                    : this.editorState.formality,
            },
            this.profile_id,
            this.selectedLanguage,
            this.textProcessingRequestSignal$
          )
          .subscribe((data) => {
            this.editorState.batch = data.batch;
            this.editorState.chunks = data.ChkLs;

            this.setFilteredInnerHTML(data.RetCnt);
            setTimeout(
              () => this.quillEditor.setSelection(this.safeCursorIndex),
              0
            );

            const newContentLength = this.quillEditor.getLength();
            this.safeCursorIndex = Math.min(
              this.safeCursorIndex,
              newContentLength - 1
            );

            this.computeWordsAndCharactersCount();
            this.suggestionsTone
              ? this.checkTone()
              : this.checkGrammar(this.editorState.chunks);
          });
      },
      this.editorState.batch ? 3000 : 1000
    );
  }

  checkGrammar(chunks: Array<string>, preserveCursor: boolean = false) {
    preserveCursor &&
      setTimeout(() => this.quillEditor.setSelection(this.safeCursorIndex), 0);
    let pendingRequests = chunks.length;
    this.editorState.grammarStatus = 'checking';

    const checkIfAllRequestsDone = () => {
      if (pendingRequests === 0) {
        this.editorState.state = 'initial';
        this.editorState.grammarStatus = 'initial';
      }
    };

    chunks.forEach((chunk) => {
      const el = document.getElementById(chunk) as HTMLElement;
      el.innerText = el.innerText;
      if (!el || el.innerText.trim().length === 0) {
        pendingRequests--;
        checkIfAllRequestsDone();
        return;
      }

      const makeRequest = () => {
        if (this.suggestionsTone) {
          this.grammarCheckerRequestSignal$.next();
          return;
        }

        if (this.grammarCheckerRequestCanceled) return;

        this.apiDataService
          .grammarcheckerapi(
            el.innerText,
            this.selectedLanguage,
            {
              domain: this.editorState.domain,
              formality:
                this.editorState.domain === 'academic'
                  ? ''
                  : this.editorState.formality === 'neutral'
                    ? 'formal'
                    : this.editorState.formality,
            },
            chunk,
            this.editorState.doc_id,
            this.editorState.batch,
            'p',
            this.grammarCheckerRequestSignal$
          )
          .subscribe((data) => {
            if (data.status === 'waiting' && !data.had_exception) {
              setTimeout(makeRequest, 1000);
            } else {
              pendingRequests--;
              checkIfAllRequestsDone();
            }
            this.editorState.results = {
              ...this.editorState.results,
              [chunk]: data.outConts,
            };
            this.resultsCollapsed = false;
            this.computeResultsStatus();
            this.formatEditorErrors();
            preserveCursor &&
              setTimeout(
                () => this.quillEditor.setSelection(this.safeCursorIndex),
                0
              );
            this.highlightErrors(
              chunk,
              preserveCursor || pendingRequests === 0
            );
          });
      };

      makeRequest();
    });
  }

  cancelGrammarCheckerRequest() {
    this.grammarCheckerRequestCanceled = true;
    this.textProcessingRequestSignal$.next();
    this.grammarCheckerRequestSignal$.next();
    this.quillEditor.enable();
    this.editorState.state = 'initial';
    this.editorState.grammarStatus = 'initial';

    setTimeout(() => {
      this.grammarCheckerRequestCanceled = false;
    }, 1000);
  }

  detectAIContent() {
    // const content = this.quillEditor.root.textContent.trim();
    // this.apiDataService
    //   .aiContentDetection(this.profile_id, this.authTitle, content)
    //   .subscribe((data) => {
    //     this.editorState.aiContentScore = parseFloat(
    //       data.ai_score.replace('%', '') || 0
    //     );
    //   });
  }

  checkPlagiarism() {
    const content = this.quillEditor.root.textContent.trim();

    this.apiDataService
      .plagiarismChecker(this.profile_id, this.authTitle, content)
      .subscribe((data) => {
        if (
          data.plagiarized &&
          (this.authState === 'pro' || this.plagCheckerLimitLeft)
        ) {
          this.editorState.plagiarism.plagiarismScore = parseFloat(
            data.plagiarized.replace('%', '')
          );
          this.editorState.plagiarism.isPlagiarized = data.isPlagiarized;
          return;
        }

        this.editorState.plagiarism.plagiarismScore = 0;
        this.editorState.plagiarism.isPlagiarized = data.isPlagiarized;
      });
  }

  computeResultsStatus() {
    let readabilityCount = [];
    let suggestions = 0,
      accuracy = 0,
      clarity = 0,
      style = 0,
      syntax = 0,
      grammar = 0,
      reading_time = 0,
      speaking_time = 0;

    Object.keys(this.editorState.results).forEach((chunk) => {
      const result = this.editorState.results[chunk];

      readabilityCount.push(result.text_details.readability);
      suggestions += result.errors.Suggestion ?? 0;
      accuracy +=
        (result.accMode?.length ?? 0) +
        (result.algMode?.filter((e) => e.errorType === 'accuracy').length || 0);
      clarity +=
        (result.clrMode?.length ?? 0) +
        (result.algMode?.filter((e) => e.errorType === 'clarity').length || 0);
      style +=
        result.algMode?.filter(
          (e) => e.errorType === 'style' || e.errorType === 'redundency'
        ).length || 0;
      syntax +=
        result.algMode?.filter((e) => e.errorType === 'syntax').length || 0;
      grammar += result.errors.GrammarError ?? 0;
      reading_time += result.text_details.reading_time ?? 0;
      speaking_time += result.text_details.speaking_time ?? 0;
    });

    const sum = accuracy + clarity + style + syntax;
    const all = Number.isNaN(sum) ? 0 : sum;

    this.editorState.status = {
      readability:
        Math.floor(
          readabilityCount.reduce((a, b) => Number(a) + Number(b), 0) /
          readabilityCount.length
        ) || 1,
      all,
      accuracy,
      clarity,
      style: Number.isNaN(style) ? 0 : style,
      syntax,
      grammar,
      positive: 0,
      negative: 0,
      neutral: 0,
      reading_time,
      speaking_time,
    };

    this.calculateTextScore();
  }

  formatEditorErrors() {
    Object.keys(this.editorState.results).forEach((chunk) => {
      const result = this.editorState.results[chunk];

      const errors = Object.entries({
        algMode: result.algMode,
        accMode: result.accMode,
        clrMode: result.clrMode,
      })
        .filter(([_, value]) => value.length > 0)
        .reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {});

      this.editorState.errors = {
        ...this.editorState.errors,
        [chunk]: errors,
      };
    });

    this.editorState.errors = Object.fromEntries(
      Object.entries(this.editorState.errors).sort(
        ([a], [b]) => parseInt(a) - parseInt(b)
      )
    );

    this.filteredErrors('all');
  }

  filteredErrors(
    filter: typeof this.showErrorsByType,
    rehighlight: boolean = true
  ) {
    this.showErrorsByType = filter;

    const sortedErrors = {};

    let filteredErrors: any = {};

    if (filter === 'all') {
      filteredErrors = this.editorState.errors;
    } else {
      this.Object.entries(
        this.editorState.errors as Record<
          string,
          Partial<
            Record<'accMode' | 'clrMode' | 'algMode', { errorType: string }[]>
          >
        >
      ).forEach(([key, modes]) => {
        let selectedErrors: Array<any> = [];

        if (filter === 'accMode') {
          selectedErrors = [
            ...(modes.accMode || []),
            ...(modes.algMode?.filter((e) => e.errorType === 'accuracy') || []),
          ];
        } else if (filter === 'clrMode') {
          selectedErrors = [
            ...(modes.clrMode || []),
            ...(modes.accMode?.filter((e) => e.errorType === 'clarity') || []),
          ];
        } else if (filter === 'syntaxMode') {
          selectedErrors = [
            ...(modes.algMode?.filter((e) => e.errorType === 'syntax') || []),
          ];
        } else if (filter === 'styleMode') {
          selectedErrors = [
            ...(modes.algMode?.filter(
              (e) => e.errorType === 'style' || e.errorType === 'redundency'
            ) || []),
          ];
        }

        if (selectedErrors.length) {
          filteredErrors[key] = selectedErrors;
        }
      });
    }

    for (const key in filteredErrors) {
      if (filteredErrors.hasOwnProperty(key)) {
        let allOffsets = [];

        for (const mode in filteredErrors[key]) {
          if (filteredErrors[key][mode]) {
            allOffsets = allOffsets.concat(filteredErrors[key][mode]);
          }
        }

        allOffsets.sort((a, b) => a.offset - b.offset);
        sortedErrors[key] = allOffsets;
      }
    }

    this.editorState.filteredErrors = Object.fromEntries(
      Object.entries(sortedErrors).filter(
        ([_, value]) => Array.isArray(value) && value.length > 0
      )
    );

    if (rehighlight) {
      this.editorState.chunks.forEach((chunk) => {
        this.highlightErrors(chunk);
      });
    }
  }

  removeErrorHighlightsFromText() {
    const highlights = this.quillEditor.root.querySelectorAll('span');

    highlights.forEach((highlight) => {
      let parent = highlight.parentNode;
      while (highlight.firstChild) {
        parent.insertBefore(highlight.firstChild, highlight);
      }
      parent.removeChild(highlight);
    });
  }

  changeSuggestionsTone() {
    this.grammarCheckerRequestSignal$.next();
    this.toneProcessingRequestSignal$.next();
    this.editorState.state = 'initial';
    this.editorState.grammarStatus = 'initial';

    this.suggestionsTone = !this.suggestionsTone;
    this.removeErrorHighlightsFromText();

    this.editorState.tone = {};
    this.editorState.results = {};
    this.editorState.errors = {};
    this.editorState.filteredErrors = {};
    this.editorState.filteredSuggestions = {};
    this.editorState.status = {
      ...this.editorState.status,
      all: 0,
      accuracy: 0,
      clarity: 0,
      style: 0,
      syntax: 0,
      positive: 0,
      negative: 0,
      neutral: 0,
      reading_time: 0,
      speaking_time: 0,
    };

    if (!this.suggestionsTone) {
      this.handleCheckGrammarButton();
      return;
    }

    this.checkTone();
  }

  checkTone() {
    this.quillEditor.enable();
    this.editorState.tone = {};
    this.editorState.results = {};
    this.editorState.errors = {};
    this.editorState.filteredErrors = {};
    this.editorState.status = {
      ...this.editorState.status,
      all: 0,
      accuracy: 0,
      clarity: 0,
      style: 0,
      syntax: 0,
      positive: 0,
      negative: 0,
      neutral: 0,
      reading_time: 0,
      speaking_time: 0,
    };

    this.editorState.chunks.forEach((chunk) => {
      const el = document.getElementById(chunk) as HTMLElement;
      if (el.innerText.trim().length === 0) return;

      this.apiDataService
        .toneDetectorAPI(
          el.innerText,
          'en-US',
          {
            domain: this.editorState.domain,
            formality:
              this.editorState.domain === 'academic'
                ? ''
                : this.editorState.formality === 'neutral'
                  ? 'formal'
                  : this.editorState.formality,
          },
          chunk,
          this.editorState.doc_id,
          this.editorState.batch,
          'p',
          this.toneProcessingRequestSignal$
        )
        .subscribe((data) => {
          this.editorState.tone[data.chunk_id] = data.tone_output;
          this.computeToneStatusCount(data.counts);
          this.filteredSuggestions(this.showToneSuggestionsByType);
          this.highlightToneSuggestionsInEditor(data.chunk_id);
        });
    });

    this.editorState.state = 'initial';
    this.editorState.grammarStatus = 'initial';
  }

  filteredSuggestions(filter: typeof this.showToneSuggestionsByType) {
    this.showToneSuggestionsByType = filter;
    let filteredSuggestions = {};

    if (filter === 'all') {
      filteredSuggestions = this.editorState.tone;
    } else {
      filteredSuggestions = Object.fromEntries(
        Object.entries(this.editorState.tone)
          .map(([key, values]) => {
            const filteredValues = (values as Array<any>).filter(
              (item) => item.category.toLowerCase() === filter.toLowerCase()
            );

            return filteredValues.length > 0 ? [key, filteredValues] : null;
          })
          .filter(Boolean)
      );
    }

    const sortedSuggestions = this.Object.keys(filteredSuggestions).sort(
      (a, b) => parseInt(a) - parseInt(b)
    );

    filteredSuggestions = this.Object.fromEntries(
      sortedSuggestions.map((key) => [key, filteredSuggestions[key]])
    );

    this.editorState.filteredSuggestions = Object.fromEntries(
      Object.entries(filteredSuggestions).filter(
        ([_, value]) => Array.isArray(value) && value.length > 0
      )
    );

    this.removeErrorHighlightsFromText();
    this.editorState.chunks.forEach((chunk) => {
      this.highlightToneSuggestionsInEditor(chunk);
    });
  }

  computeToneStatusCount(counts: Record<string, number>) {
    this.editorState.status.all += counts['all'];
    this.editorState.status.neutral += counts['neutral'];
    this.editorState.status.positive += counts['positive'];
    this.editorState.status.negative += counts['negative'];
  }

  highlightToneSuggestionsInEditor(chunk: string) {
    const el: HTMLElement = document.getElementById(chunk);
    let text = el.textContent || '';

    if (!this.editorState.filteredSuggestions[chunk]) return;

    for (
      let i = this.editorState.filteredSuggestions[chunk].length - 1;
      i >= 0;
      i--
    ) {
      const highlight = this.editorState.filteredSuggestions[chunk][i];

      const { offset, length, category, id } = highlight;

      const sentence = `<span class="error-highlight highlight-${category.toLowerCase()}" id="${id}">${text.slice(
        offset,
        offset + length
      )}</span>`;

      text = `${text.slice(0, offset)}${sentence}${text.slice(
        offset + length
      )}`;
    }

    el.innerHTML = text;
  }

  handleEditorClick(event: Event) {
    const target = event.target as HTMLElement;

    this.safeCursorIndex = this.quillEditor.getSelection();

    if (!target.classList.contains('error-highlight')) {
      return;
    }

    this.resultsSectionPanel = 'resultsSection';
    this.resultsCollapsed = false;

    setTimeout(() => {
      const errorTarget: HTMLElement =
        document.querySelector(`[data-error="${target.id}"]`) ??
        document.querySelector(
          `[data-error="${target.closest('.entire-highlight').id}"]`
        );

      const highlight: HTMLElement = target.dataset['highlight']
        ? target
        : target.closest('.entire-highlight');

      // this.removeClassFromAllSiblings(errorTarget, 'expanded');
      this.quillEditor.root.querySelectorAll('span').forEach((span) => {
        span.style.removeProperty('background-color');
      });
      highlight?.setAttribute(
        'style',
        `${highlight?.getAttribute('style')
          ? highlight?.getAttribute('style') + ';'
          : ''
        } background-color: ${highlight.dataset['highlight']} !important`
      );
      if (!this.popupVisible) {
        this.quillEditor.root.querySelectorAll('span').forEach((span) => {
          span.style.removeProperty('background-color');
        });
      }
      if (this.popupVisible && highlight) {
        highlight.setAttribute(
          'style',
          `${highlight?.getAttribute('style') || ''}; background-color: ${highlight.dataset['highlight']
          } !important`
        );
      }
      // errorTarget.classList.add('expanded');
      // errorTarget.scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
    }, 0);
  }

  computeWordsAndCharactersCount() {
    const editorText = this.quillEditor.getText().trim();
    const sentences = editorText.match(/[^.!?]+[.!?]+/g) || [];
    const words = editorText.length ? editorText.split(/\s+/) : [];

    const averageCharacters =
      words && words.length
        ? words.reduce((acc, word) => acc + word.length, 0) / words.length
        : 0;

    this.editorState.words = words.length;

    this.editorState.characters = editorText.length;
    this.editorState.sentences = editorText.length ? sentences.length : 0;
    this.editorState.sentenceLength = this.editorState.sentences
      ? Math.floor(this.editorState.words / this.editorState.sentences)
      : 0;
    this.editorState.wordsLength = Math.floor(averageCharacters);

    if (editorText.length === 0) this.unsetErrors();
  }

  scrollToBottom() {
    if (!this.messagesContainer) return;
    const container = this.messagesContainer.nativeElement;
    container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
  }

  setResultsSectionPanel(panel: typeof this.resultsSectionPanel) {
    this.resultsSectionPanel = panel;
    this.saveToLocalStorage();
  }

  saveToLocalStorage() {
    const state = {
      resultsCollapsed: this.resultsCollapsed,
      aiAssistantQueries: {
        id: this.editorState.doc_id,
        queries: this.aiAssistantQueries,
      },
    };
    localStorage.setItem('editorState', JSON.stringify(state));
  }

  loadFromLocalStorage() {
    const savedState = localStorage.getItem('editorState');
    this.profile_id = localStorage.getItem('profile_id') || '1';
    if (savedState) {
      const state = JSON.parse(savedState);
      this.resultsCollapsed = state.resultsCollapsed ?? this.resultsCollapsed;
      if (state.aiAssistantQueries.id !== this.editorState.doc_id) {
        this.aiAssistantQueries = [];
        state.aiAssistantQueries = [];
        this.saveToLocalStorage();
      }
      this.aiAssistantQueries =
        state.aiAssistantQueries.queries ?? this.aiAssistantQueries;
    }
  }

  handleAiAssistantResponse(event: any) {
    event.preventDefault();

    this.allowTypeWriter = false;
    this.aiAssistantQueries = this.aiAssistantQueries.map((q) => ({
      ...q,
      loaded: true,
    }));

    this.userInteracted = false;
    this.isAiAssistantQueriesLoading = true;

    const question: string =
      event.type === 'click'
        ? `${event.target.innerText}:\n"${this.quillEditor.getText()}"`
        : `${event.target.text.value
        }\n\nOnly consider the later text if it is relevant to the \
           question else treat this as if it doesn't \
           exists -> "${this.quillEditor.getText()}"`;

    const query: (typeof this.aiAssistantQueries)[number] = {
      question:
        event.type === 'click'
          ? event.target.innerText
          : event.target.text.value,
      answer: '',
      loaded: false,
    };

    this.allowTypeWriter = true;

    if (this.authLimits[this.authState].prompts <= this.promptsUsed) {
      setTimeout(() => {
        event.type !== 'click' && (event.target.text.value = '');
        query.answer = 'Upgrade';
        this.aiAssistantQueries.push(query);
        this.isAiAssistantQueriesLoading = false;
      }, 1000);

      return;
    }

    const formData = new FormData();
    formData.append('text', question);
    event.type !== 'click' && (event.target.text.value = '');

    this.apiDataService
      .aiAssistantApiRequest(formData, this.profile_id)
      .subscribe((data) => {
        query.answer = data.response;

        this.aiAssistantQueries.push(query);
        this.isAiAssistantQueriesLoading = false;
        this.promptsUsed += 1;
        this.saveToLocalStorage();
      });
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
  }

  async copyAiAssistantResponse(event) {
    const el = (event.target as HTMLElement)
      .closest('.markdown-container')
      .querySelector('markdown');

    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([el.innerHTML], { type: 'text/html' }),
          'text/plain': new Blob([el.textContent], { type: 'text/plain' }),
        }),
      ]);
    } catch (error) {
      console.error('Error copying text: ', error);
    }
  }

  handleUserInteraction(event?: string) {
    this.userInteracted = true;

    if (event === 'scroll') {
      const el = this.messagesContainer.nativeElement;

      el.scrollTop + el.clientHeight >= el.scrollHeight
        ? (this.userInteracted = false)
        : (this.userInteracted = true);
    }
  }

  correctAll() {
    const highlights =
      this.quillEditor.root.querySelectorAll('.error-highlight');

    highlights.forEach((highlight) => {
      highlight.innerText = highlight.dataset['correction'];
    });

    this.unsetErrors();
    this.removeErrorHighlightsFromText();
    setTimeout(() => this.saveEditorText(), 500);
  }

  handleCorrection(event: Event) {
    const button = (event.target as HTMLElement).closest('button');
    const target = button.dataset['target'];

    const el = document.getElementById(target);
    let correction;
    let resendGrammarRequest = true;

    try {
      correction =
        JSON.parse(button.dataset['correction']) ||
        button.dataset['correction'];

      correction = button.dataset['correct'];
    } catch {
      correction = button.dataset['correction'];
      resendGrammarRequest = false;
    }

    const parent = el.parentNode as HTMLElement;

    parent.insertBefore(document.createTextNode(correction), el);
    parent.removeChild(el);

    this.removeModesByTreadId(target.slice(4));

    // if (!button.dataset['model']) {
    //   let prevError = button.closest('li').previousElementSibling;
    //   let nextError = button.closest('li').nextElementSibling;

    //   while (nextError && nextError.classList.contains('premium-suggestion')) {
    //     nextError = nextError.nextElementSibling;
    //   }

    //   if (nextError) {
    //     (nextError.querySelector('.expand-toggler') as HTMLElement).click();
    //   } else {
    //     while (
    //       prevError &&
    //       prevError.classList.contains('premium-suggestion')
    //     ) {
    //       prevError = prevError.previousElementSibling;
    //     }

    //     if (prevError) {
    //       (prevError.querySelector('.expand-toggler') as HTMLElement).click();
    //     }
    //   }
    // }
    this.popupVisible = false;

    // button.closest('li').remove();
    this.filteredErrors(this.showErrorsByType, false);
    resendGrammarRequest && this.checkGrammar([parent.id], true);
    setTimeout(() => this.saveEditorText(), 500);
  }

  handleDismiss(event: Event, type?: string) {
    const button = (event.target as HTMLElement).closest('button');
    const target = button.dataset['target'];

    const el = document.getElementById(target);
    if (el.classList.contains('synonym-selected')) {
      // Skip or adjust dismiss logic accordingly
      return;
    }

    const parent = el.parentNode as HTMLElement;

    parent.insertBefore(document.createTextNode(el.innerText), el);
    parent.removeChild(el);

    this.removeModesByTreadId(target.slice(4), false);
    // let prevError = button.closest('li').previousElementSibling;
    // let nextError = button.closest('li').nextElementSibling;

    // while (nextError && nextError.classList.contains('premium-suggestion')) {
    //   nextError = nextError.nextElementSibling;
    // }

    // if (nextError) {
    //   (nextError.querySelector('.expand-toggler') as HTMLElement).click();
    // } else {
    //   while (prevError && prevError.classList.contains('premium-suggestion')) {
    //     prevError = prevError.previousElementSibling;
    //   }

    //   if (prevError) {
    //     (prevError.querySelector('.expand-toggler') as HTMLElement).click();
    //   }
    // }

    // button.closest('li').remove();
    this.filteredErrors(this.showErrorsByType);

    this.popupVisible = false;
  }

  handleToneErrorDismiss(event: Event) {
    const id = (event.target as HTMLElement).closest('button').dataset[
      'target'
    ];

    const target = document.getElementById(id);
    const chunk = id.split('-').slice(0, 2).join('-');

    const parent = target.parentNode as HTMLElement;

    parent.insertBefore(document.createTextNode(target.innerText), target);
    parent.removeChild(target);

    const tones = this.editorState.tone[chunk];

    this.editorState.tone[chunk] = tones.filter((tone) => {
      if (tone.id === id) {
        this.editorState.status[tone.category.toLowerCase()] -= 1;
        return false;
      }
      return true;
    });

    const button = event.target as HTMLElement;

    let prevError = button.closest('li').previousElementSibling;
    let nextError = button.closest('li').nextElementSibling;

    while (nextError && nextError.classList.contains('premium-suggestion')) {
      nextError = nextError.nextElementSibling;
    }

    if (nextError) {
      (nextError.querySelector('.expand-toggler') as HTMLElement).click();
    } else if (prevError) {
      (prevError.querySelector('.expand-toggler') as HTMLElement).click();
    }

    this.filteredSuggestions(this.showToneSuggestionsByType);
    this.editorState.status.all -= 1;
    (event.target as HTMLElement).closest('li').remove();
  }

  removeModesByTreadId(chunk: string, dec: boolean = true) {
    const treadId = chunk.split('-').slice(0, 3).join('-');
    const offset = chunk.split('-').slice(3).join('-');
    const key = chunk.split('-').slice(0, 2).join('-');
    const errors = this.editorState.errors[key];

    const modes: Array<string> =
      treadId === chunk ? ['accMode', 'clrMode'] : ['algMode'];

    modes.forEach((mode) => {
      if (errors[mode]) {
        for (let i = errors[mode].length - 1; i >= 0; i--) {
          const error = errors[mode][i];

          if (
            (mode === 'algMode' &&
              error.ChkiD === treadId &&
              error.offset === Number(offset)) ||
            (mode !== 'algMode' && error.ChkiD === treadId)
          ) {
            errors[mode].splice(i, 1);
          }
        }

        // if (dec) {
        //   if (errors[mode].errorType) {
        //     errors[mode][0].errorType === 'modAcc'
        //       ? (this.editorState.status.accuracy -= 1)
        //       : (this.editorState.status.clarity -= 1);
        //   } else {
        //     this.editorState.status.style -=
        //       this.editorState.status.style > 0 ? 1 : 0;
        //   }
        // }

        if (errors[mode].length === 0) {
          delete this.editorState.errors[key][mode];
        }
      }
    });

    if (Object.keys(errors).length === 0) {
      delete this.editorState.errors[key];
    }

    // this.editorState.status.all -= 1;
    this.computeResultsStatus();
  }

  formatReplacementsArray(replacements: Array<string>): string {
    return replacements
      .map((replacement) => {
        if (replacement.startsWith('#@-@#')) {
          return `<strong class="text-color-danger text-decoration-line-through">${replacement
            .slice(5)
            .trim()}</strong>`;
        }

        if (replacement.startsWith('#@+@#')) {
          return `<strong class="text-color-primary">${replacement
            .slice(5)
            .trim()}</strong>`;
        }

        return replacement;
      })
      .join(' ');
  }

  slugify(str: string) {
    return String(str)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9 -]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  toggleErrorListExpand(event: Event, background: string) {
    const el = (event.target as HTMLElement).closest('li');

    // this.removeClassFromAllSiblings(el, 'expanded');
    el.classList.toggle('expanded');

    const t = document.getElementById(`${el.dataset['error']}`);
    t?.setAttribute(
      'style',
      `${t?.getAttribute('style') ? t?.getAttribute('style') + ';' : ''
      } background-color: ${background} !important`
    );

    const errorHighlights = this.quillEditor.root.querySelectorAll(
      '.error-highlight, .entire-highlight'
    );

    errorHighlights.forEach((highlight) => {
      if (highlight !== t) {
        (highlight as HTMLElement).style.backgroundColor = '';
      }
    });

    // this.setCursorInEditor(t);
    this.safeCursorIndex = this.quillEditor.getSelection();

    t.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }

  // setCursorInEditor(t: HTMLElement) {
  //   const range = document.createRange();
  //   const selection = window.getSelection();

  //   range.setStart(t, t.childNodes.length);
  //   range.setEnd(t, t.childNodes.length);

  //   selection.removeAllRanges();
  //   selection.addRange(range);
  // }

  // removeClassFromAllSiblings(el: HTMLElement, className: string) {
  //   Array.from(el.parentElement.children).forEach((child) => {
  //     if (child !== el && child.classList.contains(className)) {
  //       child.classList.remove(className);
  //     }
  //   });
  // }

  highlightErrorInEditor(event: Event, background: string) {
    const el = document.getElementById(
      (event.target as HTMLElement).closest('li').dataset['error']
    );
    el?.setAttribute(
      'style',
      `${el?.getAttribute('style') ? el?.getAttribute('style') + ';' : ''
      } background-color: ${background} !important`
    );
  }

  removeHighlightInEditor(event: Event) {
    const target = (event.target as HTMLElement).closest('li');
    const el = document.getElementById(
      (event.target as HTMLElement).closest('li').dataset['error']
    );

    if (!el) return;

    target.classList.contains('expanded') || (el.style.backgroundColor = '');
  }

  invokeModal(event: Event) {
    const targetId = (event.target as HTMLElement).closest('button').dataset[
      'target'
    ];

    document.getElementById(targetId).style.display = 'grid';
  }

  dismissModal(event: Event) {
    (
      (event.target as HTMLElement).closest('.wrapper') as HTMLElement
    ).style.display = 'none';
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    const minText = minutes > 0 ? `${minutes} min` : '';
    const secText = remainingSeconds > 0 ? `${remainingSeconds} sec` : '';

    return [minText, secText].filter(Boolean).join(' ');
  }

  calculateTextScore() {
    const { accuracy, clarity, style, syntax } = this.editorState.status;
    const words = this.editorState.words;

    if (!words) return;

    const errorWeight =
      accuracy * 2 + clarity * 1.5 + style * 0.5 + syntax * 0.5;

    const score = 100 * (1 - errorWeight / words);

    this.editorState.score = Math.floor(Math.max(0, score));
  }

  toggleReportMenu(event: Event) {
    event.stopPropagation();

    const target = (event.target as HTMLElement).closest('button')
      ?.nextElementSibling as HTMLUListElement;

    if (!target) return;

    if (this.openMenu && this.openMenu !== target) {
      this.openMenu.style.display = 'none';
    }

    target.style.display = target.style.display === 'block' ? 'none' : 'block';
    this.openMenu = target.style.display === 'block' ? target : null;
  }

  handleClickOutside = (event: Event) => {
    if (this.openMenu && !this.openMenu.contains(event.target as Node)) {
      this.openMenu.style.display = 'none';
      this.openMenu = null;
    }
  };

  switchLanguage(event) {
    const el = (event.target as HTMLElement).closest('li');

    if (!el) return;

    const language = el.getAttribute('data-language');
    this.selectedLanguage = language;
    this.openMenu.style.display = 'none';

    this.authState !== 'guest' &&
      this.apiDataService
        .updateUserLanguage(this.profile_id, language)
        .subscribe();

    this.iconRequireReattachment = true;
    setTimeout(() => {
      this.iconRequireReattachment = false;
    });

    this.handleCheckGrammarButton();
  }

  addWordToDictionary(word: string) {
    this.apiDataService
      .addDictionaryWord(this.profile_id, word)
      .subscribe(() => {
        this.openMenu.style.display = 'none';
      });
  }

  // reportSuggestion(event) {
  //   const el = (event.target as HTMLElement).closest('li');

  //   const errId = el.dataset['rule'];
  //   const text = el.dataset['text'];

  //   if (el.closest('.error-card-footer').querySelector('.E93rKL-PD_2')) {
  //     this.openMenu.style.display = 'none';
  //     return;
  //   }

  //   this.apiDataService
  //     .addRuleReport(this.profile_id, errId, this.editorState.doc_id, text)
  //     .subscribe(() => {
  //       const s = document.createElement('span');
  //       s.classList.add('E93rKL-PD_2');
  //       s.style.marginInlineEnd = '1rem';
  //       s.innerText = 'Reported';
  //       el.closest('.error-card-footer').prepend(s);
  //       this.openMenu.style.display = 'none';
  //     });
  // }

  isProcessing: boolean = false;

  reportSuggestion(event: MouseEvent) {
     if (this.isProcessing) return;
 
     this.isProcessing = true;
 
     const el = (event.target as HTMLElement).closest('li');
     const closestElement = (event.target as HTMLElement).closest(
       '[id]'
     ) as HTMLElement;
     const closestId = closestElement?.id;
     const htmlId = el.id;
 
     const errId = el.dataset['rule'];
     const text = el.dataset['text'];
 
     const footer = el.closest('.error-card-footer');
 
     if (footer?.querySelector('.E93rKL-PD_2')) {
       if (this.openMenu) this.openMenu.style.display = 'none';
 
       this.isProcessing = false;
       return;
     }
 
     if (closestId === htmlId) {
       this.apiDataService
         .addRuleReport(this.profile_id, errId, this.editorState.doc_id, text)
         .subscribe(() => {
           const s = document.createElement('span');
           s.classList.add('E93rKL-PD_2');
           s.style.marginInlineEnd = '1rem';
           s.innerHTML = 'Reported!';
           footer?.prepend(s);
 
           if (this.openMenu) this.openMenu.style.display = 'none';
 
           this.reportedArray.push({
             span: text,
             spanId: closestId,
             errorID: errId,
             spanreporedclass: s,
           });
 
          //  console.log('this.reportedArray', this.reportedArray);
 
           setTimeout(() => {
             s.remove();
           }, 2000);
 
           this.isProcessing = false;
         });
     }
   }
 
   reportedArray: any = [];
  downloadReadabilityReport() {
    const report = {
      sentencelength: this.editorState.sentenceLength,
      performance: this.editorState.score,
      characters: this.editorState.characters,
      speakingtime: this.editorState.status.speaking_time,
      words: this.editorState.words,
      sentences: this.editorState.sentences,
      readingtime: this.editorState.status.reading_time,
      issuesleft: this.editorState.status.all,
      rarewords: '',
      uniquewords: '',
      wordlength: this.editorState.wordsLength,
      redundancy: 0,
      accuracy: this.editorState.status.accuracy,
      clarity: this.editorState.status.clarity,
      style: this.editorState.status.style,
      syntax: 0,
      editor_content: this.quillEditor.root.innerHTML,
      word_list: this.quillEditor.getText().split(' '),
    };

    const headers = new HttpHeaders({
      Authorization: environment.AuthorizationGIN,
    });

    this.http
      .post(environment.API_URL + '/processingGrammarReport', report, {
        headers,
        responseType: 'blob',
      })
      .subscribe({
        next: (response: Blob) => {
          saveAs(response, `grammarin-report-${this.editorState.doc_id}.pdf`);
        },
        error: (error) => {
          console.error(error);
        },
      });
  }

  saveEditorContentToStorage() {
    const content = this.quillEditor.root.innerText;
    localStorage.setItem('editorValueAI', content);
  }

  updateShowTargetsOnLoad() {
    if (this.showTargetsCheckboxValue === this.showTargets) return;

    this.apiDataService
      .updateShowTargetsOnLoad(this.showTargetsCheckboxValue, this.profile_id)
      .subscribe();
  }

  f(number: number): string {
    return number.toLocaleString();
  }

  setFilteredInnerHTML(newHTML) {
    const element = this.quillEditor.root;
    let parser = new DOMParser();
    let doc = parser.parseFromString(newHTML, 'text/html');
    let newElements = Array.from(doc.body.children);
    let uncheckedElements = Array.from(
      element.querySelectorAll('.E93fKL-PD_2')
    );

    element.innerHTML = newElements.map((el) => el.outerHTML).join('');
    uncheckedElements.forEach((el) => element.appendChild(el));
  }

  getQuillEditorFilteredText() {
    const el = this.quillEditor.root;

    const clone = el.cloneNode(true) as HTMLElement;
    clone.querySelectorAll('.E93fKL-PD_2').forEach((el) => el.remove());

    return clone.innerHTML;
  }

  splitTextByWordLimit(innerHTML: string): string {
    let parser = new DOMParser();
    let doc = parser.parseFromString(innerHTML, 'text/html');
    let elements = Array.from(doc.body.children);

    let selectedElements: string[] = [];
    let wordCount = 0;
    let limit = this.authLimits[this.authState].words;

    if (this.authState === 'guest') limit += 50;

    let remainingElements: HTMLElement[] = [];

    elements.forEach((el) => {
      let text = el.textContent?.trim() || '';
      let words = text.split(/\s+/);
      let wordsInElement = words.length;

      if (wordCount + wordsInElement <= limit) {
        selectedElements.push(el.outerHTML);
        wordCount += wordsInElement;
      } else if (wordCount < limit) {
        let firstPart = words.slice(0, limit - wordCount).join(' ');
        let secondPart = words.slice(limit - wordCount).join(' ');

        let firstEl = `<${el.tagName.toLowerCase()}>${firstPart}</${el.tagName.toLowerCase()}>`;
        let secondEl = `<${el.tagName.toLowerCase()} class="E93fKL-PD_2">${secondPart}</${el.tagName.toLowerCase()}>`;

        selectedElements.push(firstEl);
        remainingElements.push(
          new DOMParser().parseFromString(secondEl, 'text/html').body
            .firstChild as HTMLElement
        );
        wordCount = limit;
      } else {
        el.classList.add('E93fKL-PD_2');
        remainingElements.push(el as HTMLElement);
      }
    });

    let uncheckedHTML = remainingElements.map((el) => el.outerHTML).join('');
    return selectedElements.join('') + uncheckedHTML;
  }

  redirectToTool(tool: string) {
    this.saveEditorContentToStorage();

    if (tool === 'plagiarism-checker' && this.authState !== 'guest') {
      tool = tool.replace(/-/g, '');
      tool += `?doc=${this.editorState.doc_id}`;
      this.plagCheckerLimitLeft -= 1;
    } else {
      this.aiDetectorLimitLeft -= 1;
    }

    window.open(`/${tool}`, '_blank');
  }

  convertTablesToParagraphs(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    doc.querySelectorAll('table').forEach((table) => {
      let newParagraphs = '';

      table.querySelectorAll('tr').forEach((row) => {
        let rowText: string[] = [];

        row.querySelectorAll('td, th').forEach((cell) => {
          rowText.push(cell.textContent?.trim() || '');
        });

        newParagraphs += `<p>${rowText.join(' | ')}</p>`;
      });

      const wrapper = document.createElement('div');
      wrapper.innerHTML = newParagraphs;
      table.replaceWith(...Array.from(wrapper.childNodes));
    });

    return doc.body.innerHTML;
  }

  convertDivsToParagraphs(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    doc.body.querySelectorAll('div').forEach((div) => {
      const p = document.createElement('p');

      while (div.firstChild) {
        p.appendChild(div.firstChild);
      }

      div.replaceWith(p);
    });

    return doc.body.innerHTML;
  }

  //................. variables............//
  popupVisible = false;
  editorContent: string = '';
  captchaVisible: boolean = false;
  isCaptchaVerified: boolean = false;
  recaptchaMessage: string = '';
  recaptcha_message = '';
  color: string = 'black';
  captchaToken: string;
  successAlert;
  errorAlerts;
  error: boolean = false;
  success: boolean = false;
  loaderAlert: boolean = false;
  char_count;
  got_recpatcha: boolean = false;
  recaptchaSiteKey = '6LcMnOsnAAAAAExxnt0IqIEq4pSha6O_vPeOsw-1';
  captchaResponse: string;
  isUploadDivVisible: boolean = true;

  //................. variables............//

  //......................................//

  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false;
  }

  handleButtonClick(): void {
    setTimeout(() => {
      this.popupVisible = false;
      this.editorContent = $('#mm').text().trim();

      if (this.editorContent.length > 0) {
        if (this.isCaptchaVerified) {
          // this.break_sentences('');
          this.handleCheckGrammarButton();
        } else {
          if (!this.captchaVisible) {
            this.captchaVisible = true;
            this.cdr.detectChanges();
            this.loadAndRenderTurnstile();
          } else {
            this.recaptchaMessage = 'Please complete the CAPTCHA.';
            this.color = '#721c24';
          }
        }
      } else {
        this.showAlert('Enter at least 1 Words.', '');
      }
    }, 50);
  }

  loadAndRenderTurnstile(): void {
    if (typeof window['turnstile'] === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderTurnstile();
      script.onerror = () => console.error('Failed to load Turnstile script.');
      document.body.appendChild(script);
    } else {
      this.renderTurnstile();
    }
  }

  renderTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (!containerElement) {
      console.error('Container element not found.');
      return;
    }

    window['turnstile'].render(containerElement, {
      sitekey: environment.CaptchaKey,
      size: 'normal',
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
  }

  onTurnstileSuccess(token: string): void {
    this.captchaToken = token;
    this.isCaptchaVerified = true;
    this.captchaVisible = false;
    this.recaptchaMessage = '';

    this.handleCheckGrammarButton();
  }

  onTurnstileError(): void {
    console.error('Turnstile error occurred.');
    this.captchaToken = null;
    this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
    this.color = '#721c24';
  }

  resetTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].reset(containerElement);
    } else {
      console.error('Turnstile library not loaded.');
    }
  }

  // popup variables
  targetHTMLElement: any;
  elementId: any;
  elementIdParts: any;
  activeElement: HTMLElement | null = null;
  matchVisible = false;
  modelVisble = false;
  orignalWordMatch: any;
  message;
  error_Color;
  match_id;
  wrong;
  innerTextArray: string[] = [];
  popupSynonyms: string[] = [];
  correct_line;
  Chk_ID;
  off_Set;
  error_Type;
  id_Rule;
  come_from;
  modelchunk_id_background: any;
  modelchunk_id: any;
  gramar_model;
  popupPosition: any;
  matchReplacement: boolean = false;
  activeElement_ruleid: any;

  spellingmistake = 0;
  garmmarmistake = 0;
  text: string = '';
  errorsArray = [];
  dataListing = [];
  ID;
  storeparentid;
  id;
  tread_ID;
  error_text;
  replacementsArray: string[] = [];
  // popup variables

  isSynonymSelected = false;

  isValidSynonyms(): boolean {
    return this.popupSynonyms.length > 0 && this.popupSynonyms[0].length >= 10;
  }

  //......................................//

  highlightErrors(chunk: string, end: boolean = false) {
    if (!this.editorState.errors[chunk]) return;

    const el = document.getElementById(chunk) as HTMLElement;
    const errors = this.editorState.errors[chunk];
    let text = el.textContent || '';

    const sortHighlights = () => {
      let highlights = [];

      const modesToShow: Array<string> =
        this.showErrorsByType === 'all'
          ? ['accMode', 'clrMode']
          : this.showErrorsByType === 'accMode'
            ? ['accMode']
            : this.showErrorsByType === 'clrMode'
              ? ['clrMode']
              : [];

      modesToShow.forEach((mode) => {
        if (errors[mode]) {
          errors[mode].forEach((error) => {
            error.highlights.forEach((highlight) => {
              highlights.push({
                highlight,
                offset: error.offset,
                length: error.length,
                UnderLine: error.UnderLine,
                Color: error.Color,
                ColorLight: error.ColorLight,
              });

              //******************************* *//
              this.dataListing.push({
                highlight,
                replacementarray: error.replacements[0],
                message: error.message,
                match_id: error.errorID,
                rule_id: error.rule.id,
                ChkiD: error.ChkiD,
                correct: error.correct,
                offset: error.offset,
                errorType: error.errorType,
                wrong: error.wrong,
                color: error.ColorLight,
                colorlight: error.UnderLine,
                errorcolor: error.Color,
                model: highlight.model,
                id: `${highlight.tread_id}-${highlight.offset}-${this.slugify(
                  highlight.wrong
                )}`,
                come_from: error.errorType === 'modAcc' ? 'accMode' : 'clrMode',
                tread_ID: highlight.tread_id,
                text: error.text,
              });


              //******************************* *//
            });
          });
        }
      });

      if (errors.algMode) {
        errors.algMode.forEach((error) => {
          if (
            (this.showErrorsByType === 'accMode' &&
              error.errorType !== 'accuracy') ||
            (this.showErrorsByType === 'clrMode' &&
              error.errorType !== 'clarity') ||
            (this.showErrorsByType === 'syntaxMode' &&
              error.errorType !== 'syntax') ||
            (this.showErrorsByType === 'styleMode' &&
              error.errorType !== 'style' &&
              error.errorType !== 'redundency')
          ) {
            return;
          }
          //******************************* *//
          this.dataListing.push({
            rule_id: error.rule.id,
            errorType: error.errorType,
            replacements: error.replacements,
            message: error.message,
            replacement_text: error.replacement_text,
            error_text: error.wrong_word,
            errorTypeColor: error.typeColor,
            match_id: error.errorID,
            errorTypeClass: error.errorTypeClass,
            offset: error.offset,
            filter_list: error.filter_list,

            ChkiD: error.ChkiD,
            color: error.ColorLight,
            colorlight: error.UnderLine,
            errorcolor: error.Color,
            model: error.model,
            wrong: error.wrong,
            correct: error.correct,
            come_from: 'alg',
            id: `err-${error.ChkiD}-${error.offset}`,
            tread_ID: error.tread_id,
            text: error.text,
          });

          //******************************* *//
          let placed = false;
          for (let i = 0; i < highlights.length; i++) {
            const group = highlights[i];
            if (
              error.offset >= group.offset &&
              error.offset + error.length <= group.offset + group.length
            ) {
              highlights.push({
                offset: group.offset,
                length: group.length,
                highlight: error,
                UnderLine: group.UnderLine,
                Color: group.Color,
                ColorLight: group.ColorLight,
              });
              placed = true;
              break;
            }
          }
          if (!placed) {
            highlights.push({
              UnderLine: error.UnderLine,
              offset: error.offset,
              length: error.length,
              highlight: error,
              Color: error.Color,
              ColorLight: error.ColorLight,
            });
          }
        });
      }

      return highlights.sort((a, b) => b.offset - a.offset);
    };

    const groupHighlightsByOffsetAndLength = (highlights) => {
      const grouped: Record<
        string,
        {
          offset: number;
          length: number;
          highlights: Array<any>;
          UnderLine?: string;
          Color: string;
          ColorLight: string;
        }
      > = {};

      highlights.forEach(
        ({ offset, length, highlight, UnderLine, Color, ColorLight }) => {
          const key = `${offset}-${length}`;

          if (!grouped[key])
            grouped[key] = {
              Color,
              ColorLight,
              UnderLine,
              offset,
              length,
              highlights: [],
            };

          grouped[key].highlights.push(highlight);
        }
      );

      Object.values(grouped).forEach((group) => {
        group.highlights.sort((a, b) => b.offset - a.offset);
      });

      return Object.values(grouped);
    };

    const highlights = groupHighlightsByOffsetAndLength(sortHighlights());

    highlights.forEach((hl) => {
      const { offset, length, highlights, UnderLine, Color } = hl;

      const model =
        highlights.find((h) => h.model)?.model ??
        Math.floor(Math.random() * 1000);
      const tread_id =
        highlights.find((h) => h.tread_id)?.tread_id ??
        Math.floor(Math.random() * 1000);

      let sentence = text.slice(offset, offset + length);

      highlights.forEach((highlight) => {
        const calculatedOffset = highlight.offset - offset;

        if (highlight.tread_id) {
          sentence = `${sentence.slice(
            0,
            calculatedOffset
          )}<span class="error-highlight highlight-${highlight.model
            } error-highlight-${UnderLine} error-4" id="${highlight.tread_id}-${highlight.offset
            }-${this.slugify(highlight.wrong)}" data-correction="${highlight.model !== 'accuracy' &&
              ['guest', 'auth'].includes(this.authState)
              ? highlight.wrong
              : highlight.replace
            }" style="border-bottom: 2px ${UnderLine === 'DottedLine' ? 'dotted' : 'solid'
            } ${Color}">${sentence.slice(
              calculatedOffset,
              calculatedOffset + highlight.length
            )}</span>${sentence.slice(calculatedOffset + highlight.length)}`;
        } else {
          sentence = `${sentence.slice(
            0,
            calculatedOffset
          )}<span class="error-highlight highlight-${highlight.errorType
            }-algo error-5 error-6" style="border-bottom: 2px ${highlight.UnderLine === 'DottedLine' ? 'dotted' : 'solid'
            } ${highlight.Color}" id="err-${highlight.ChkiD}-${highlight.offset
            }" data-correction="${['guest', 'auth'].includes(this.authState) &&
              highlight.errorType !== 'accuracy'
              ? highlight.wrong
              : highlight.replacements[0]?.value ?? highlight.wrong
            }" data-highlight="${highlight.ColorLight}">${sentence.slice(
              calculatedOffset,
              calculatedOffset + highlight.length
            )}</span>${sentence.slice(calculatedOffset + highlight.length)}`;
        }
      });

      text = `${text.slice(
        0,
        offset
      )}<span id="err-${tread_id}" class="entire-highlight entire-highlight-${model}" data-highlight="${hl.ColorLight
        }">${sentence}</span>${text.slice(offset + length)}`;
    });

    el.innerHTML = text;

    this.quillEditor.enable();
    end &&
      setTimeout(() => this.quillEditor.setSelection(this.safeCursorIndex), 0);
    this.computeWordsAndCharactersCount();
  }

  // onclickeditor(event: MouseEvent, data: any) {
  //   this.isUploadDivVisible = false;
  //   this.loaderAlert = false;
  //   this.targetHTMLElement = event.target as HTMLElement;

  //   const Id = (event.target as HTMLElement).id;

  //   if (
  //     this.targetHTMLElement.tagName === 'SPAN' &&
  //     (this.targetHTMLElement.classList.contains('error-4') ||
  //       this.targetHTMLElement.classList.contains('error-5') ||
  //       this.targetHTMLElement.classList.contains('error-6'))
  //   ) {
  //     var target = this.targetHTMLElement;
  //     this.elementId = target.id;

  //     if (this.activeElement) {
  //       this.activeElement.style.backgroundColor = '';
  //       this.activeElement.classList.remove('active');
  //       this.popupVisible = false;
  //       this.matchVisible = false;
  //       this.modelVisble = false;
  //     }

  //     if (this.dataListing != null) {
  //       for (let i = 0; i < this.dataListing.length; i++) {
  //         if (this.dataListing[i]['id'] === Id) {
  //           target.classList.add('active');

  //           const rect = target.getBoundingClientRect();
  //           let topMargin = rect.bottom + window.scrollY;
  //           let leftMargin = rect.left + window.scrollX;

  //           const screenWidth = 834;
  //           const screenHeight = 1194;
  //           const popupWidth = 310;
  //           const popupHeight = 200;

  //           if (leftMargin + popupWidth > screenWidth) {
  //             leftMargin = screenWidth - popupWidth - 10;
  //           }
  //           if (leftMargin < 10) {
  //             leftMargin = 10;
  //           }

  //           if (topMargin + popupHeight > screenHeight) {
  //             topMargin = rect.top + window.scrollY - popupHeight - 10;
  //           }

  //           const position = {
  //             top: `${topMargin}px`,
  //             left: `${leftMargin}px`,
  //           };

  //           if (
  //             target.classList.contains('error-5') ||
  //             target.classList.contains('error-6')
  //           ) {
  //             this.ID = this.dataListing[i]['id'];

  //             target.style.backgroundColor = this.dataListing[i]['color'];
  //             this.orignalWordMatch = this.dataListing[i]['error_text'];

  //             this.message = this.dataListing[i]['message'];

  //             this.error_Color = this.dataListing[i]['errorcolor'];

  //             this.match_id = this.dataListing[i]['match_id'];

  //             this.activeElement_ruleid = this.dataListing[i]['rule_id'];

  //             this.Chk_ID = this.dataListing[i]['ChkiD'];
  //             this.gramar_model = this.dataListing[i]['model'];

  //             this.error_Type = this.dataListing[i]['errorType'];

  //             this.off_Set = this.dataListing[i]['offset'];
  //             this.wrong = this.dataListing[i]['wrong'];

  //             this.innerTextArray = this.dataListing[i]['replacements'][0];

  //             this.tread_ID = this.dataListing[i]['tread_ID'];
  //             this.error_text = this.dataListing[i]['text'];

  //             this.popupSynonyms = [];
  //             if (this.dataListing[i]['replacements'].length != 0) {
  //               const valuesList: string[] = this.dataListing[i][
  //                 'replacements'
  //               ].map((replacement) => replacement.value);

  //               if (valuesList[0] !== '') {
  //                 this.popupSynonyms = valuesList;
  //                 this.matchReplacement = true;
  //               }

  //               // this.popupSynonyms = valuesList;
  //             }

  //             this.matchVisible = true;
  //             this.modelVisble = false;
  //             this.modelchunk_id = '';
  //             this.modelchunk_id_background = '';
  //             this.activeElement = target;
  //           } else if (target.classList.contains('error-4')) {
  //             this.modelVisble = true;
  //             this.matchVisible = false;
  //             this.ID = this.dataListing[i]['id'];

  //             this.replacementsArray = this.dataListing[i]['replacementarray'];

  //             this.wrong = this.dataListing[i]['wrong'];

  //             this.match_id = this.dataListing[i]['match_id'];

  //             this.correct_line = this.dataListing[i]['correct'];
  //             this.Chk_ID = this.dataListing[i]['ChkiD'];
  //             this.off_Set = this.dataListing[i]['offset'];
  //             this.error_Type = this.dataListing[i]['errorType'];

  //             this.id_Rule = this.dataListing[i]['rule_id'];

  //             this.error_Color = this.dataListing[i]['errorcolor'];
  //             this.orignalWordMatch = this.dataListing[i]['error_text'];

  //             this.come_from = this.dataListing[i]['come_from'];

  //             this.gramar_model = this.dataListing[i]['model'];

  //             this.error_text = this.dataListing[i]['text'];

  //             this.tread_ID = this.dataListing[i]['tread_ID'];

  //             var text = document.getElementById(this.Chk_ID);
  //             // text.style.backgroundColor = this.dataListing[i]['color'];
  //             this.activeElement = text;
  //           }
  //           this.popupPosition = position;
  //           this.popupVisible = true;

  //           document.body.style.overflow = 'hidden';
  //           return;
  //         }
  //       }
  //     }
  //   } else {
  //     this.popupVisible = false;
  //     this.quillEditor?.root.querySelectorAll('span').forEach((span) => {
  //       span.style.removeProperty('background-color');
  //     });
  //     if (this.activeElement) {
  //       this.activeElement.style.backgroundColor = '';
  //     }
  //   }
  // }
  onclickeditor(event: MouseEvent, data: any) {
    this.isUploadDivVisible = false;
    this.loaderAlert = false;
    this.targetHTMLElement = event.target as HTMLElement;

    const Id = (event.target as HTMLElement).id;

    if (
      this.targetHTMLElement.tagName === 'SPAN' &&
      (this.targetHTMLElement.classList.contains('error-4') ||
        this.targetHTMLElement.classList.contains('error-5') ||
        this.targetHTMLElement.classList.contains('error-6'))
    ) {
      var target = this.targetHTMLElement;
      this.elementId = target.id;

      if (this.activeElement) {
        this.activeElement.style.backgroundColor = '';
        this.activeElement.classList.remove('active');
        this.popupVisible = false;
        this.matchVisible = false;
        this.modelVisble = false;
      }

      if (this.dataListing != null) {
        for (let i = 0; i < this.dataListing.length; i++) {
          if (this.dataListing[i]['id'] === Id) {
            target.classList.add('active');

            const verticalMargin = 20;
            const horizontalMargin = 15;
            const estimatedPopupWidth = 360;
            const estimatedPopupHeight = 120;

            const parent = (event.currentTarget as HTMLElement).getBoundingClientRect();
            const rect = target.getBoundingClientRect();

            const editorWidth = parent.width;
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;

            const placeAbove = spaceBelow < estimatedPopupHeight && spaceAbove > estimatedPopupHeight;

            let left = rect.left - parent.left;
            if (left + estimatedPopupWidth + horizontalMargin > editorWidth) {
              left = editorWidth - estimatedPopupWidth - horizontalMargin;
            } else if (left < horizontalMargin) {
              left = horizontalMargin;
            }

            let top = placeAbove
              ? rect.top - parent.top - estimatedPopupHeight - verticalMargin
              : rect.bottom - parent.top + verticalMargin;

            const position = {
              top: `${top}px`,
              left: `${left}px`,
            };


            if (
              target.classList.contains('error-5') ||
              target.classList.contains('error-6')
            ) {
              this.ID = this.dataListing[i]['id'];

              target.style.backgroundColor = this.dataListing[i]['color'];
              this.orignalWordMatch = this.dataListing[i]['error_text'];

              this.message = this.dataListing[i]['message'];

              this.error_Color = this.dataListing[i]['errorcolor'];

              this.match_id = this.dataListing[i]['match_id'];

              this.activeElement_ruleid = this.dataListing[i]['rule_id'];

              this.Chk_ID = this.dataListing[i]['ChkiD'];
              this.gramar_model = this.dataListing[i]['model'];

              this.error_Type = this.dataListing[i]['errorType'];

              this.off_Set = this.dataListing[i]['offset'];
              this.wrong = this.dataListing[i]['wrong'];

              this.innerTextArray = this.dataListing[i]['replacements'][0];

              this.tread_ID = this.dataListing[i]['tread_ID'];
              this.error_text = this.dataListing[i]['text'];

              this.popupSynonyms = [];
              if (this.dataListing[i]['replacements'].length != 0) {
                const valuesList: string[] = this.dataListing[i][
                  'replacements'
                ].map((replacement) => replacement.value);

                if (valuesList[0] !== '') {
                  this.popupSynonyms = valuesList;
                  this.matchReplacement = true;
                }

                // this.popupSynonyms = valuesList;
              }

              this.matchVisible = true;
              this.modelVisble = false;
              this.modelchunk_id = '';
              this.modelchunk_id_background = '';
              this.activeElement = target;
            } else if (target.classList.contains('error-4')) {
              this.modelVisble = true;
              this.matchVisible = false;
              this.ID = this.dataListing[i]['id'];

              this.replacementsArray = this.dataListing[i]['replacementarray'];

              this.wrong = this.dataListing[i]['wrong'];

              this.match_id = this.dataListing[i]['match_id'];

              this.correct_line = this.dataListing[i]['correct'];
              this.Chk_ID = this.dataListing[i]['ChkiD'];
              this.off_Set = this.dataListing[i]['offset'];
              this.error_Type = this.dataListing[i]['errorType'];

              this.id_Rule = this.dataListing[i]['rule_id'];

              this.error_Color = this.dataListing[i]['errorcolor'];
              this.orignalWordMatch = this.dataListing[i]['error_text'];

              this.come_from = this.dataListing[i]['come_from'];

              this.gramar_model = this.dataListing[i]['model'];

              this.error_text = this.dataListing[i]['text'];

              this.tread_ID = this.dataListing[i]['tread_ID'];

              var text = document.getElementById(this.Chk_ID);
              // text.style.backgroundColor = this.dataListing[i]['color'];
              this.activeElement = text;
            }
            this.popupPosition = position;
            this.popupVisible = true;
            return;
          }
        }
      }
    } else {
      this.popupVisible = false;
      this.quillEditor?.root.querySelectorAll('span').forEach((span) => {
        span.style.removeProperty('background-color');
      });
      if (this.activeElement) {
        this.activeElement.style.backgroundColor = '';
      }
    }
  }
  closepopUpArt() {
    this.activeElement.classList.remove('active');

    this.activeElement.style.backgroundColor = '';
    this.popupVisible = false;
  }
  // ...... on tying popup close
  @ViewChild('popupContainer') popup!: ElementRef;
  @ViewChild('trigger') trigger!: ElementRef;
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closepopUpArt();
    }
  }

  @HostListener('document:keypress', ['$event'])
  handleTyping(event: KeyboardEvent) {
    if (this.popupVisible && !this.popup.nativeElement.contains(event.target)) {
      this.closepopUpArt();
    }
  }

  // ...... on typing popup close


  //********loader on upload file ***** */
  onUploadStart() {
    this.loaderAlert = true;
  }

  onUploadFinish() {
    this.loaderAlert = false;
  }
  //********loader on upload file ***** */
  ngOnInit(): void {
    this.quillEditor.root.innerHTML =
        localStorage.getItem('editorValueAI');
        // console.log("home data ", localStorage.getItem('editorValueAI'))
          setTimeout(() => {
    if (this.quillEditor && this.quillEditor.root) {
      const savedContent = localStorage.getItem('editorValueAI');
      if (savedContent) {
        this.quillEditor.root.innerHTML = savedContent;
        // console.log("Loaded from storage after delay:", savedContent);
      }
    } else {
      console.error('Quill editor root still not ready.');
    }
  }, 5);
  }
}
